module.exports = __webpack_public_path__ + "img/7-2.8ddadfbd.png";